import type { MenuProps } from 'antd';
import { Menu as AntdMenu } from 'antd';
import { Key, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { closeDrawerMenu } from '../../../modules/ui/store/ui-slice';
import styles from './menu.module.css';

type MenuItem = Required<MenuProps>['items'][number];

export const getItem = (
  label: ReactNode,
  key: Key,
  icon?: ReactNode,
  children?: MenuItem[],
  type?: 'group',
  disabled?: boolean,
): MenuItem => {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled,
  } as MenuItem;
};

interface Props {
  items: MenuProps['items'];
  onItemSelect: (menuItem: string) => void;
  openKeys: MenuProps['openKeys'];
  onOpenChange: MenuProps['onOpenChange'];
}

const Menu = (props: Props): JSX.Element => {
  const { items, onItemSelect, openKeys, onOpenChange } = props;
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <AntdMenu
        onClick={menuProps => {
          onItemSelect(menuProps?.key);
          dispatch(closeDrawerMenu());
        }}
        mode="inline"
        items={items}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      />
    </div>
  );
};

export default Menu;
